
import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';

// import translationEN from './locales/en/translation.json';
// import translationZH from './locales/zh/translation.json';

import locales from './locales/index.json'

const keys = locales.type

export const resources = {}
locales.content.forEach(words => {
    keys.forEach((k,i) => {
        if (!resources[k]) {
            resources[k] = {translation:{}}
        }
        resources[k].translation[words[0]] = words[i]
    })
})

i18n
  // load translation using http -> see /public/locales
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    resources,
    lng: Object.keys(resources)[0],
    // fallbackLng: "en",

    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
  });

export default i18n;